module.exports = __webpack_public_path__ + "img/panorama-digital.2eb7d707.png";